import React, { useState, useEffect, useCallback } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = () => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const handleMouseMove = useCallback((e) => {
    const x = (e.clientX / window.innerWidth - 0.5) * 2;
    const y = (e.clientY / window.innerHeight - 0.5) * 2;
    setMousePos({ x, y });
  }, []);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      window.addEventListener('mousemove', handleMouseMove);
      return () => window.removeEventListener('mousemove', handleMouseMove);
    }
  }, [handleMouseMove]);

  const handleStartPrinting = () => {
    window.open('https://mpprinterscontact.vercel.app/', '_blank');
  };

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center relative overflow-hidden px-4 sm:px-6"
    >
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <div
          className="hero-blob-blue"
          style={{
            transform: `translateX(${mousePos.x * 3}px) translateY(${mousePos.y * 3}px)`,
          }}
        />
        <div
          className="hero-blob-purple"
          style={{
            transform: `translateX(${-mousePos.x * 2}px) translateY(${-mousePos.y * 2}px)`,
          }}
        />
        <div className="hero-grid" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 text-center relative z-10">
        <h1
          className="hero-title text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-bold mb-4 sm:mb-6 tracking-tight leading-[0.95]"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Prints Your
          <br />
          Imagination
        </h1>

        <p className="hero-subtitle text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 mb-8 sm:mb-10 md:mb-12 max-w-xl md:max-w-2xl mx-auto leading-relaxed px-2">
          Pan India Printing Hub - Design, Print & Despatch
        </p>

        <div className="hero-button">
          <Button
            onClick={handleStartPrinting}
            className="btn-animate bg-black text-white hover:bg-gray-800 text-sm sm:text-base md:text-lg px-6 sm:px-8 md:px-12 py-4 sm:py-5 md:py-6 rounded-full shadow-lg"
          >
            Start Printing
            <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero-scroll-indicator absolute bottom-6 sm:bottom-8 md:bottom-10 left-1/2 -translate-x-1/2">
        <div className="w-5 h-9 sm:w-6 sm:h-10 border-2 border-black/30 rounded-full flex items-start justify-center p-2">
          <div className="scroll-dot w-1.5 h-1.5 bg-black/50 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
